import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const UserFieldBox = styled(Box)`
  margin-bottom: 20px;
  width: 300px;
`;
